import { detectAvif } from "./detectAvif.mjs";
import { detectWebp } from "./detectWebp.mjs";
import { detectDefaults } from "./detectDefaults.mjs";
import { detectWebm } from "./detectWebm.mjs";
import { detectMp4 } from "./detectMp4.mjs";
import { detectOgv } from "./detectOgv.mjs";
export {
  detectAvif,
  detectDefaults,
  detectMp4,
  detectOgv,
  detectWebm,
  detectWebp
};
//# sourceMappingURL=index.mjs.map
